import { Tabs } from 'antd';
import React, { useState } from 'react';
import { CategoriesSetup } from '../components/categories-setup';
import { ChatbotFlowEditor } from '../components/chatbot-flow-editor';
import { ConfigurationSetup } from '../components/configuration-setup';
import { ProductsSetup } from '../components/products-setup';
import { ValidationSetup } from '../components/validation-setup';
import { PricingSetup } from '../components/pricing-setup';
import { useGetCurrentUser } from '@/hooks/app';
import { PermissionChecker } from '@/utils/permission';

type TabValue = 'products' | 'categories' | 'config' | 'pricing' | 'validation' | 'setup' | 'matrix' | 'jsonflow' | 'chatbotflow';

export const ProductConfiguratorPage: React.FC = () => {
  // Get current user permissions
  const { data: currentUserData } = useGetCurrentUser();
  const permissions = currentUserData?.permission;

  // Initialize PermissionChecker
  const permissionChecker = new PermissionChecker(permissions);

  // Permission checks
  const canManageProducts = permissionChecker.canManageProducts();
  const canManagePricing = permissionChecker.canManagePricing();
  const canManageOptions = permissionChecker.canManageOptions();
  const canManageProductValidation = permissionChecker.canManageProductValidation();
  const canManageChatbotFlow = permissionChecker.canManageChatbotFlow();

  const [activeTab, setActiveTab] = useState<TabValue>('products');

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 className="text-xl font-semibold">Product Configurator</h1>
          <p className="text-sm text-text-secondary">
            Manage window products, categories, and configuration options
          </p>
        </div>
        {/* <Space size="middle">
          {hasUnsavedChanges && (
            <Alert
              message="Unsaved Changes"
              type="warning"
              showIcon
              className="py-1"
            />
          )}
          <Button icon={<MdRefresh size={18} />} onClick={handleReset}>
            Reset
          </Button>
          <Button icon={<MdCloudUpload size={18} />} onClick={handleImport}>
            Import
          </Button>
          <Button icon={<MdCloudDownload size={18} />} onClick={handleExport}>
            Export
          </Button>
        </Space> */}
      </div>

      {/* Tabs */}
      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key as TabValue)}
        type="line"
        className='[&_.ant-tabs-tab-btn]:text-base'
        items={[
          canManageProducts && {
            key: 'products',
            label: 'Products (Window Types)',
            children: <ProductsSetup />,
          },
          canManageProducts && {
            key: 'categories',
            label: 'Categories',
            children: <CategoriesSetup />,
          },
          canManageOptions && {
            key: 'config',
            label: 'Configuration Options',
            children: <ConfigurationSetup />,
          },
          canManageProductValidation && {
            key: 'validation',
            label: 'Product Validation',
            children: <ValidationSetup />,
          },
          canManagePricing && {
            key: 'pricing',
            label: 'Pricing Rules',
            children: <PricingSetup />,
          },
          // {
          //   key: 'setup',
          //   label: 'Product Setup Wizard',
          //   children: <ProductSetupWizard />,
          // },

          // {
          //   key: 'jsonflow',
          //   label: 'JSON Flow Editor',
          //   children: <JSONFlowEditor />,
          // },
          canManageChatbotFlow && {
            key: 'chatbotflow',
            label: 'Configuration Flow Editor',
            children: <ChatbotFlowEditor />,
          },
        ].filter(Boolean) as any}
      />
    </div>
  );
};

export default ProductConfiguratorPage;
